import { render, staticRenderFns } from "./InstallVatModal.vue?vue&type=template&id=1d99387f&"
import script from "./InstallVatModal.vue?vue&type=script&lang=ts&"
export * from "./InstallVatModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports